import { isStringTrue } from '@iddataweb/idw-common-ui/utils';
import { EntityStatusTypes } from '@enums/entity-status-types';
import { FormattedRpServiceConfigurationServiceOffering } from '@idw-types/data/rp-service-configuration';

export const hasAtLeastOneTrustScoreService = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>, scoreServiceOfferingIDs: Array<string>) => {
    return serviceOfferings
        .filter(offering =>
            offering.addedToService &&
            offering.status === EntityStatusTypes.ACTIVE &&
            offering.serviceOfferingStatus === EntityStatusTypes.ACTIVE
        ).some(offering =>
            scoreServiceOfferingIDs.includes(offering.serviceOfferingID) &&
            affectsIDWRiskScore(offering)
        );
}

const affectsIDWRiskScore = (serviceOffering: FormattedRpServiceConfigurationServiceOffering): boolean => {
    if (serviceOffering) {
        return (
            isStringTrue(serviceOffering.affectsIDWRiskScore) &&
            !['IDW_RSK_SCR', 'IDW_TRST_SCR'].includes(serviceOffering.referenceCode)
        );
    }
    return false;
}

export const getScoreServiceOfferings = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>, scoreServiceOfferingIDs: Array<string>) => {
    return serviceOfferings.reduce((result, serviceOffering) => {
        if (scoreServiceOfferingIDs.includes(serviceOffering.serviceOfferingID)) {
            result.push(serviceOffering);
        }
        return result;
    }, []);
}

export const scoreComponentsDisable = (trustScoreServiceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>) => {
    return trustScoreServiceOfferings.every((offering: any) => +offering.weight === 0)
}

export const affectsTrustScore = (offerings: Array<FormattedRpServiceConfigurationServiceOffering>, trustScoreServiceOfferingIDs: Array<string>) => {
    return offerings.filter(offering => {
        return (
            offering.addedToService && offering.status === EntityStatusTypes.ACTIVE &&
            offering.serviceOfferingStatus === EntityStatusTypes.ACTIVE &&
            affectsIDWRiskScore(offering) &&
            !trustScoreServiceOfferingIDs.includes(offering.serviceOfferingID)
        );
    })
}

export const getDefaultServiceOfferingWeight = (affectsIDWRiskScore: string): string => {
    return isStringTrue(affectsIDWRiskScore) ? "1" : "0";
}
